import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';

const FULL_PROFILE_KEY = 'full-profile';

export const useFullProfile = () => {
  const { userData } = useAuth();
  const queryClient = useQueryClient();

  const { data: profileData, isLoading: profileLoading } = useQuery({
    queryKey: [FULL_PROFILE_KEY, userData?.id],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_my_full_profile' as any);
      if (error) throw error;
      return data;
    },
    enabled: !!userData?.id,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const invalidateProfile = () => {
    queryClient.invalidateQueries({ queryKey: [FULL_PROFILE_KEY, userData?.id] });
  };

  return { profileData, profileLoading, invalidateProfile };
};
